import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { XX_SMALL_TEXT_PX } from 'src/styles/fonts/MCFontConstants.js';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${XX_SMALL_TEXT_PX};
    width: 100%;
    max-width: 560px;

    ${media.mobileDevice`
        gap: 2px;
    `}
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;

    ${media.mobileDevice`
        justify-content: center;
    `}
`;
